<template>
    <div
        :class="{ 'l-ss-c-offer-count-cart-wrapper': $configuration.cartCount.active && ($configuration.completionsFullWidth ||
            $configuration.layout.templateOffer !== 'rows'), 'l-ss-c-offer-cart-wrapper': !$configuration.cartCount.active }">
        <div
            v-if="$configuration.cartCount.active"
            class="l-ss-c-offer-count-cart"
            :style="{ visibility: showCartButton ? 'visible': 'hidden' }">
            <div
                class="l-ss-c-offer-count-wrapper"
                v-if="count"
                @click.prevent>
                <button
                    ref="add-cart-btn"
                    class="l-ss-c-offer-footer-action-add-to-cart-count"
                    :class="{ 'l-ss-c-offer-action-remove-from-cart-count-disabled': quantityCartItem < 2 }"
                    @click="minusCart()"
                    type="button">
                    <i
                        :class="{ 'l-ss-c-icon-success': isCartRemoveIconActive }"
                        class="l-ss-c-icon l-ss-c-icon-primary l-ss-c-icon-count-left"
                        v-html="minusIcon"></i>
                </button>
                <div class="l-ss-c-offer-count">
                    {{ quantityCartItem }}
                </div>
                <button
                    ref="add-cart-btn"
                    class="l-ss-c-offer-footer-action-add-to-cart-count"
                    @click="plusCart()"
                    type="button">
                    <i
                        class="l-ss-c-icon l-ss-c-icon-primary l-ss-c-icon-count-right"
                        v-html="plusIcon"></i>
                </button>
            </div>
            <div
                v-if="!isCart()"
                class="l-ss-c-offer-footer-actions"
                @click.prevent>
                <button
                    ref="add-cart-btn"
                    class="l-ss-c-offer-footer-action-add-to-cart"
                    :class="{ 'l-ss-c-offer-footer-action-add-to-cart-button--is-active': isCheckedIdAddToCard(offer.id) }"
                    @click="addToCart"
                    type="button">
                    {{ $t('results.toCart') }}
                </button>
            </div>
            <div
                v-if="isCart()"
                class="l-ss-c-offer-footer-actions">
                <a
                    target="_blank"
                    :href="offer.url"
                    class="l-ss-c-offer-footer-action-add-to-cart">
                    {{ $t('results.moreDetail') }}
                </a>
            </div>
        </div>
        <button
            v-if="!$configuration.cartCount.active && showCartButton"
            ref="add-cart-btn"
            class="l-ss-c-offer-footer-action-add-to-cart"
            type="button"
            :class="{ 'l-ss-c-offer-footer-action-add-to-cart--is-active': isCheckedIdAddToCard(offer.id) }"
            @click.prevent="addToCart(offer)"
            @touchstart.prevent="addToCart(offer)">
            <i
                class="l-ss-c-icon l-ss-c-icon-primary"
                v-html="cartIcon"></i>
        </button>
    </div>
</template>

<script>
    import minusIcon from '@/core/assets/images/icons/minus_icon.svg';
    import plusIcon from '@/core/assets/images/icons/plus_icon.svg';
    import cartIcon from '@/core/assets/images/icons/add-to-cart.svg';

    export default {
        props: ['showCartButton','offer','count'],
        data() {
            return {
                isCartRemoveIconActive: false,
                quantityCartItem: 1,
                offerCart: 0,
                durationInterval: 0,
                offersIdsAddToCard: [],
            };
        },
        computed: {
            /*
             * Это понадобится когда будем делать дополнительные настройки
             * c сохранением состояния
             * cashOfferCartCount() {
             *    return Number(localStorage.getItem(`${this.offer?.id}_cash`));
             * },
             * storageQuantityCartItem() {
             *    return Number(localStorage.getItem(this.offer?.id));
             * },
             */
            offerCartCount() {
                if (this.offerCart) {
                    return (this.offerCart.length) ? this.offerCart[0].quantity : this.quantityCartItem;
                }
                return this.quantityCartItem;
            },
            minusIcon() {
                return minusIcon;
            },
            plusIcon() {
                return plusIcon;
            },
            cartIcon() {
                return this.$configuration.cartIconCustom || cartIcon;
            },
        },
        mounted() {
            /*
             * Это понадобится когда будем делать дополнительные настройки
             * c сохранением состояния
             *
             * if (this.cashOfferCartCount !== this.offerCartCount) {
             *     this.quantityCartItem = this.offerCartCount;
             *     localStorage.setItem(`${this.offer?.id}_cash` , this.offerCartCount);
             *     localStorage.setItem(this.offer?.id , this.quantityCartItem);
             * } else {
             *     this.quantityCartItem = (this.storageQuantityCartItem) ? this.storageQuantityCartItem : this.offerCartCount;
             *     localStorage.setItem(`${this.offer?.id}_cash` , this.offerCartCount);
             * }
             */

            const cartStatus = () => {
                return (this.$configuration.cartStatus) ? this.$configuration.cartStatus() : {};
            };

            this.durationInterval = (cartStatus().duration || cartStatus().duration === 0) ? cartStatus().duration : this.durationInterval;

            if (cartStatus().getCartStatus) {
                this.offerCart = this.getQuantityOffer();
            }

            this.quantityCartItem = this.offerCartCount;

            if (this.durationInterval !== 0) {
                setInterval(() => {
                    if (cartStatus().getCartStatus) {
                        this.offerCart = this.getQuantityOffer();
                    }
                    this.quantityCartItem = this.offerCartCount;
                }, this.durationInterval);
            }
        },
        
        methods: {
            getQuantityOffer() {
                if (this.$configuration.cartStatus) {
                    return this.$configuration.cartStatus().getCartStatus.filter(offer => offer?.id === this.offer?.id);
                }
                return this.offerCart;
            },
            emitsQuery(payload, actionName) {
                const { id, name, price , img , url } = payload;
                localStorage.setItem(id , this.quantityCartItem);
                this.$emit( actionName, {
                    id: id,
                    name: (name || '').replace(/<\/?[^>]+(>|$)/g, ''),
                    price: parseFloat(price),
                    quantity: this.quantityCartItem,
                    img: img,
                    url: url,
                    data: payload,
                });
            },
            plusCart() {
                this.quantityCartItem++;
            },

            minusCart() {
                if (this.quantityCartItem > 0) {
                    this.quantityCartItem--;
                }
            },

            isCheckedIdAddToCard(offerId) {
                return this.offersIdsAddToCard.includes(offerId);
            },

            checkedAddToCard(offerId) {
                const checked = this.isCheckedIdAddToCard(offerId);

                if (!checked) {
                    this.offersIdsAddToCard.push(offerId);
                } else {
                    return;
                }
            },

            addToCart() {
                this.checkedAddToCard(this.offer.id);

                this.emitsQuery(this.offer , 'add-to-cart');
            },
            isCart() {
                if (!this.offer.data) {
                    if (this.offer.groupId) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    if (this.offer.data.groupId) {
                        return true;
                    } else {
                        return false;
                    }
                }
            },
        },
    };
</script>
